import styles from "./BonusProgress.module.scss";
import { cn } from "@/shared/lib/utils";
import { TipIcon } from "../assets/TipIcon";

interface BonusProgressProps {
  currentAmount: number;
  threshold: number;
  label: string;
  benefit: string;
}

export const BonusProgress = ({
  currentAmount,
  threshold,
  label,
  benefit,
}: BonusProgressProps) => {
  const progress = Math.min((currentAmount / threshold) * 100, 100);
  const isAchieved = currentAmount >= threshold;

  return (
    <div className={styles.bonusProgress}>
      <div className={styles.header}>
        <div
          className={cn(styles.benefit, isAchieved && styles.achievedBenefit)}
        >
          {benefit}
        </div>
        <div className={styles.iconWrapper}>
          {isAchieved && (
            <TipIcon
              className={styles.achievedIcon}
              color="var(--color-positive)"
            />
          )}
        </div>
      </div>
      <div className={styles.label}>{label}</div>
      <div className={styles.progressBar}>
        <div
          className={styles.progressFill}
          style={{ width: `${progress}%` }}
        ></div>
      </div>
    </div>
  );
};
